import { Modal, Toast } from '@boostbrothers/web-ui/web';
import type { PropsWithChildren } from 'react';

import Loading from '~components/Loading';
import useLoading from '~hooks/useLoading';
import useModal from '~hooks/useModal';
import useToast from '~hooks/useToast';

export default function UIProvider({ children }: PropsWithChildren) {
  const { toasts, closeToast } = useToast();
  const { isLoading } = useLoading();
  const { modalInfo } = useModal();

  return (
    <>
      {isLoading && <Loading />}
      {toasts.map(toast => (
        <Toast key={toast.itemKey} toast={toast} closeToast={closeToast} />
      ))}
      <Modal {...modalInfo} />
      {children}
    </>
  );
}
